<template>
    <div>
        <span v-show="enabled">
            <input type="text"  autocomplete="off" class="layui-input layuidate" readonly="readonly"/>
            <i class="layui-icon layui-icon-date" style="position: absolute;top:calc(50% - 10px);;right: 8px;margin-top: 0px;"></i>
        </span>
        <span v-show="!enabled">
            <input type="text"  autocomplete="off" class="layui-input layui-disabled layuidate-disabled" readonly="readonly" disabled="disabled"/>
             <i class="layui-icon layui-icon-date" style="position: absolute;top:calc(50% - 10px);;right: 8px;margin-top: 0px;"></i>
        </span>
    </div>
</template>

<script>
export default {
     name: 'LayuiDate',
     _model: {
        default: '',
        required: false
    },
    props: {
        placeholder: {
            default: '',
            type: String
        },
        _model: {
            default: '',
            required: false
        },
        enabled: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data: function(){
        return {
        }
     },
     mounted(){
        var id = this.id = 'layuidate' + this.uuid();
        var element = this.el = $(this.$el);
        if(this.placeholder) {
            element.find('.layuidate').attr('placeholder', this.placeholder);
        }
        element.find('.layuidate').attr('id', this.id);
        this.layui.laydate.render({
            elem: '#' + this.id,
            type: 'date',
            done: (value, date) => {
                this.$emit('_modelEvent', value);
            }
        });
    },
    methods: {
        select(value) {
            var v = value.split(' ');
            v = v.length > 0 ? v[0] : value;
            this.el.find('.layuidate,.layuidate-disabled').val(v);
        },
        handleEnabled() {
             if (this.enabled) {
                 // 显示日期组件
             } else {
                 // 显示input框
             }
        }
    },
    watch:{
        _model(value){
           this.select(value);
        },
         enabled() {
            this.handleEnabled();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiDate.vue